// src/components/Screen.js
import React, { useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { AppContext } from './AppContext';
// import './styles.css'; // Importiere die CSS-Datei

const Page1 = () => {
  // Globale Variablen aus Context
  const { 
    tournament,  
    textOnScreen, 
    performingItem, 
    upcomingItem, setUpcomingItem, 
    resultItem, setResultItem 
  } = useContext(AppContext);

  const headSection = (
    <head>
      <title>{tournament.name}</title>
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/css/bootstrap.min.css"
        rel="stylesheet"
      />
      <link rel="stylesheet" href="styles.css"/>
      <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap" rel="stylesheet"/>
      <style>
        {`
          :root {
            --color1: #590B54;
            --color2: #AD48D9;
            --background: #F2F2F2;
          }
          body {
            background-color: var(--background);
            font-family: 'Poppins', sans-serif;
            color: var(--color1);
          }

          h1 {
            text-align: center;
            font-size: 3rem;
            margin-bottom: 30px;
            font-weight: bold;
            color: var(--color1);
          }

          .card {
            margin: 20px auto;
            width: 80%;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          }

          .card-body {
            background-color: #ffffff;
            color: #2C3E50;
            border-radius: 10px;
            text-align: center;
          }

          .card-title {
            font-weight: bold;   
            color: var(--color2);
          }

          .card-subtitle {
            font-size: 1.2rem;
            color: #7f8c8d;
            margin-top: 10px;
          }

          .card-text {
            font-size: 1.1rem;
            color: #34495e;
          }

          .main-card {
            background-color: #ecf0f1;
            border: 5px solid var(--color1);
            min-height: 250px;
          }

          @keyframes glowing-border-clockwise {
            0% {
              border-top: 5px solid var(--color1);
              border-right: 5px solid transparent;
              border-bottom: 5px solid transparent;
              border-left: 5px solid transparent;
            }
            25% {
              border-top: 5px solid transparent;
              border-right: 5px solid var(--color1);
              border-bottom: 5px solid transparent;
              border-left: 5px solid transparent;
            }
            50% {
              border-top: 5px solid transparent;
              border-right: 5px solid transparent;
              border-bottom: 5px solid var(--color1);
              border-left: 5px solid transparent;
            }
            75% {
              border-top: 5px solid transparent;
              border-right: 5px solid transparent;
              border-bottom: 5px solid transparent;
              border-left: 5px solid var(--color1);
            }
            100% {
              border-top: 5px solid var(--color1);
              border-right: 5px solid transparent;
              border-bottom: 5px solid transparent;
              border-left: 5px solid transparent;
            }
          }

          .glowing-border-clockwise {
            animation: glowing-border-clockwise 2s ease-in-out;
          }

          .upcoming-card {
            background-color: #ecf0f1;
            border-left: 5px solid var(--color1);
            min-height: 100px;
          }

          .result-card {
            background-color: #ecf0f1;
            min-height: 100px;
          }

          .result-card .card-title {
            color: var(--color2);
          }

          .result-card .card-body {
            text-align: left;
            padding: 10px 20px 0 20px;
          }

          .footer {
            text-align: center;
            margin-top: 30px;
            font-size: 1rem;
            color: #95a5a6;
            position: sticky;
            width: 100%;
            bottom: 5%;
          }
        `}
      </style>
    </head>
  );

  const footerContent = (
    <div className="footer">
      <p>&copy; RG Tournament by cadaconcepts (2024)</p>
    </div>
  );

  // Hauptkarte für das laufende Item
  const mainCardContent = performingItem && performingItem.name ? (
    <div className="card main-card glowing-border-clockwise">
      <div className="card-body">
        <h1 className="card-title">{performingItem.id}</h1>
        <h2 className="card-title">{performingItem.name}</h2>
        <h4 className="card-subtitle mb-2 text-muted">
          {performingItem.category}
        </h4>
        <h6 className="card-subtitle mb-2 text-muted">
          {performingItem.app} | {performingItem.category}
        </h6>
      </div>
    </div>
  ) : null;

  // Karte für das bevorstehende Item
  const upcomingCardContent = upcomingItem && upcomingItem.name ? (
    <div className="card upcoming-card">
      <div className="card-body">
        <p className="card-text">
          <i>Upcoming</i><br/>
          {upcomingItem.name} ({upcomingItem.app} | {upcomingItem.category})
        </p>
      </div>
    </div>
  ) : null;

  // Karte für das Ergebnis-Item
  const resultCardContent = resultItem && resultItem.name ? (
    <div className="card result-card">
      <div className="card-body">
        <h6 className="card-subtitle">Results</h6>
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="card-subtitle mb-2 text-muted">
            {resultItem.name} ({resultItem.id} | {resultItem.app} | {resultItem.category})
          </h6>
          <h6 className="card-subtitle mb-2 text-muted text-end">
            {resultItem.result}
          </h6>
        </div>
      </div>
    </div>
  ) : (
    <div style={{ minHeight: '100px' }} />
  );

  return (
    <Container>
      {headSection}
      <Row className="mt-5">
        <Col>
          <h1>{tournament.name}</h1>
          <h1>{textOnScreen}</h1>
          {mainCardContent}
          {upcomingCardContent}
          {resultCardContent}
          {footerContent}
        </Col>
      </Row>
    </Container>
  );
};

export default Page1;
